import React, { useState } from 'react';
import { carteraApi } from './api';
import { money } from './helpers';
import ModalPortal from './ModalPortal';

/** Deshace la liquidación por recuperación de auto (motivo obligatorio). */
export const RevertirRecuperacionModal = ({ credito, onClose, onDone }) => {
  const [motivo, setMotivo] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const c = credito || {};

  async function confirmar() {
    if (!motivo.trim()) { setError('Escribe el motivo.'); return; }
    setSubmitting(true);
    setError(null);
    try {
      await carteraApi.revertirRecuperacion(c.id, { motivo: motivo.trim() });
      if (onDone) onDone();
      onClose();
    } catch (e) {
      setError(e?.response?.data?.message || 'No se pudo deshacer la recuperación.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <ModalPortal>
      <div className="cart-modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget && !submitting) onClose(); }}>
        <div className="cart-modal">
          <div className="cm-head">
            <h3>Deshacer recuperación de auto</h3>
            <button className="cm-close" onClick={onClose}><i className="pi pi-times" /></button>
          </div>
          <div className="cm-credit">
            <b>{c.cliente || '—'}</b> · {c.clave_contrato} · saldo <b>{money(c.saldo_insoluto)}</b>
          </div>
          {error && <div className="cm-error">{error}</div>}
          <div className="cm-note" style={{ marginBottom: 10 }}>
            Las rentas y la mora perdonadas vuelven a su estado anterior y el crédito deja de estar liquidado.
          </div>
          <div className="cm-field">
            <label>Motivo</label>
            <input className="cm-input" type="text" value={motivo} maxLength={250} autoFocus
              onChange={(e) => setMotivo(e.target.value)} placeholder="Ej. Se registró por error" />
          </div>
          <div className="cm-actions">
            <button className="btn btn-sm" onClick={onClose} disabled={submitting}>Cancelar</button>
            <button className="btn btn-green btn-sm" onClick={confirmar} disabled={submitting}>
              <i className="pi pi-undo" />{submitting ? 'Deshaciendo…' : 'Deshacer recuperación'}
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default RevertirRecuperacionModal;
